import { render, staticRenderFns } from "./ProjectRegisterModal.vue?vue&type=template&id=138b0be8&scoped=true&"
import script from "./ProjectRegisterModal.vue?vue&type=script&lang=js&"
export * from "./ProjectRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRegisterModal.vue?vue&type=style&index=0&id=138b0be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b0be8",
  null
  
)

export default component.exports